export enum ConnectivityStatusEnum {
  Connected = 'Connected',
  NotConnected = 'Not Connected',
  Uninitialized = 'Uninitialized',
}
